import type { GetB2bCampaignsPayoutsOneResponse } from '@Common/types/b2b/campaigns';

export const b2bPayoutsTranslations = {
  status: {
    pending: 'Pending',
    completed: 'Completed',
    cancelled: 'Cancelled',
  } satisfies Record<GetB2bCampaignsPayoutsOneResponse['status'], string>,
  payout_by_company_warning: "There's no mdlr_transfer since the payout is paid by company",
  payout_by_company_warning_external:
    'This payout is paid directly by your company, so no transfer is made by Shares',
};
